/** Toast copy for auth / mailbox verification email API responses */
export function toastEmailCodeResult(res, toast, fallback = 'Verification code sent to your email') {
  if (res?.data?.devFallback) {
    toast.success('Verification code generated (dev mode: check backend console)')
    return
  }
  toast.success(res?.data?.message || fallback)
}

export function emailCodeSentLabel(res, fallback = 'Verification code sent to your email') {
  if (res?.data?.devFallback) {
    return 'Verification code generated (dev mode: check backend console)'
  }
  return res?.data?.message || fallback
}
